import React from 'react';
import classes from './Toolbar.module.css';
import { Link, NavLink } from 'react-router-dom';
import { Navbar, Nav, Container } from 'react-bootstrap';
import websitelogo from '../../assets/logo/logo.png';

const Toolbar = ({ button }) => (
  <div className={classes.toolbar}>
    <Navbar expand="lg" variant="dark" className={classes.navbar}>
      <Container fluid className={classes.inner}>
        <Navbar.Brand as={Link} to="/profile/portfolio" className={classes.brand}>
          <img src={websitelogo} alt="Cryptologics-AI" className={classes.logo} />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="main-navbar" className={classes.toggler} />
        <Navbar.Collapse id="main-navbar">
          <Nav className={`${classes.nav} me-auto`}>
            <Nav.Link
              as={NavLink}
              to="/profile/portfolio"
              className={classes.link}
              activeClassName={classes.active}
              data-tour="nav-portfolio"
            >
              Portfolio
            </Nav.Link>
<Nav.Link
              as={NavLink}
              to="/profile/traderform"
              className={classes.link}
              activeClassName={classes.active}
              data-tour="nav-autotrader"
            >
              AutoTrader
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              to="/profile/scanners"
              className={classes.link}
              activeClassName={classes.active}
              data-tour="nav-scanners"
            >
              Scanners
            </Nav.Link>

            <Nav.Link
              as={NavLink}
              to="/profile/about"
              className={classes.link}
              activeClassName={classes.active}
            >
              About
            </Nav.Link>
          </Nav>

          <div className={classes.actions}>
            {/* If you can, add className={classes.logoutBtn} to your Logout button.
                Otherwise the :global(.btn) rule below will still theme it. */}
            {button}
          </div>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  </div>
);

export default Toolbar;
